import * as React from 'react';
import { gql } from '@apollo/client';
import { DeleteWorkspaceModalController, DeleteWorkspaceModalControllerProps } from './DeleteWorkspaceModal.controller';
import { useDeleteWorkspaceMutation } from '../../../models/graphql';

export type DeleteWorkspaceModalApolloProps = Omit<DeleteWorkspaceModalControllerProps, 'deleteWorkspace'> & {
  // ...
};

gql`
  mutation DeleteWorkspace($workspaceId: ID!) {
    deleteWorkspace(workspaceId: $workspaceId)
  }
`;

export const DeleteWorkspaceModalApollo = (props: DeleteWorkspaceModalApolloProps): JSX.Element => {
  const [deleteWorkspace] = useDeleteWorkspaceMutation();

  const controllerProps: DeleteWorkspaceModalControllerProps = {
    ...props,
    deleteWorkspace
  };

  return <DeleteWorkspaceModalController {...controllerProps} />;
};
